<template>
  <!--pooja, 16-dec-25, 508: Restore focus to current link after navigation / refresh -->
  <li class="usa-sidenav__item"  v-if="data" :class="{ 'usa-current': isCurrent }"> 
      <a :href="data.fields.menuItemTargetLink" :aria-current="isCurrent ? 'page' : 'false'" ref="sideMenuLink" >
          {{ data.fields.menuItemText }}
      </a>
  </li>
</template>
      
<script>
import { urlSlug } from "@/helpers/url";

export default {
    name: "side-left-menu-item",
    props: ["data"],
    data() {
      return {
        currentHash: window.location.hash
      };
    },
    computed: {
      isCurrent() {
        const slug = urlSlug(); // terms-and-conditions
        const link = this.data?.fields?.menuItemTargetLink || "";
        // pooja, 03-apr-2026, exception if there is no hash in the url, then dont select any side menu
        if (!this.currentHash && slug == 'terms-and-conditions') return false;

        // Case 1: hash match
        if (this.currentHash && link.endsWith(this.currentHash)) {
          return true;
        }
        // Case 2: page match (no hash)
        if (!this.currentHash && link.includes(slug)) {
          return true;
        }
        return false;
      }
    },
  mounted() {
    window.addEventListener("hashchange", this.updateHash);
    if (this.isCurrent) {
      this.$nextTick(() => {
        // pooja,zubair 06-04-26, focus issue fix after navigation / refresh for current link in side menu
        this.$refs.sideMenuLink?.focus({ preventScroll: true });
      });
    }
  },
  beforeUnmount() {
    window.removeEventListener("hashchange", this.updateHash);
  },
  methods: {
    updateHash() {
      this.currentHash = window.location.hash;
      // restore focus for 508
      if (this.isCurrent) {
        this.$nextTick(() => {
          // pooja, zubair 06-04-26, focus issue fix after navigation / refresh for current link in side menu 
          this.$refs.sideMenuLink?.focus({ preventScroll: true });
        });
      }
    }
  }
}
</script>
